import { UseFormReturn } from 'react-hook-form';
import {
  Form,
  FormField,
  FormItem,
  FormMessage,
} from '@web/components/ui/form';

import { InputAnimatedLabel } from '@web/components/ui/input-animated-label';

import { ContactData } from '@shared/types';

type ContactDetailsFormProps = {
  form: UseFormReturn<ContactData>;
  onSubmit: (data: ContactData) => Promise<void>;
  isEditMode: boolean;
  setIsSubmitting: (isSubmitting: boolean) => void;
};

export function ContactDetailsForm({
  form,
  onSubmit,
  isEditMode,
  setIsSubmitting,
}: ContactDetailsFormProps) {
  return (
    <Form {...form}>
      <form
        onSubmit={(e) => {
          setIsSubmitting(true);

          void form
            .handleSubmit(onSubmit, () => {
              setIsSubmitting(false);
            })(e)
            .catch(() => {
              setIsSubmitting(false);
            });
        }}
      >
        <div
          className={`grid grid-cols-2 gap-8 transition-all duration-500 ease-in-out ${isEditMode ? 'scale-[1.02] transform' : ''}`}
        >
          {/* Full Name */}
          <FormField
            control={form.control}
            name="firstName"
            render={({ field }) => (
              <FormItem>
                <InputAnimatedLabel
                  label="First Name"
                  {...field}
                  readOnly={!isEditMode}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          {/* Last Name */}
          <FormField
            control={form.control}
            name="lastName"
            render={({ field }) => (
              <FormItem>
                <InputAnimatedLabel
                  label="Last Name"
                  {...field}
                  readOnly={!isEditMode}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          {/* Email */}
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <InputAnimatedLabel
                  label="Email"
                  type="email"
                  {...field}
                  readOnly={!isEditMode}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          {/* Phone */}
          <FormField
            control={form.control}
            name="phoneNumber"
            render={({ field }) => (
              <FormItem>
                <InputAnimatedLabel
                  label="Phone"
                  type="tel"
                  {...field}
                  readOnly={!isEditMode}
                />
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <button type="submit" className="hidden" />
      </form>
    </Form>
  );
}
